import { z } from 'zod';
export const TrackPageVisitSchema = z.object({
    jobId: z.string().optional(),
});
//# sourceMappingURL=trackPageVisitSchema.js.map